// Plugin
import Swiper from 'swiper/bundle';
import WOW from 'wow.js';

new WOW().init();

// ViewportHeight
const updateViewportHeight = () => {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
};
updateViewportHeight();

//Page Hash
let hash = window.location.hash;
if(hash){
    setTimeout(() => {
        window.scrollTo({
            top: document.querySelector(hash).offsetTop - document.querySelector('.navbar').offsetHeight,
            behavior: 'smooth'
        })
    }, 1000);
}

// Header Slider
let header_swiper = new Swiper(".header-swiper" , {
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    autoplay: {
        delay: 3000,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1500,
    loop: true,
    pagination: {
        el: ".header-swiper-pagination",
        clickable: true
    },
    navigation: {
        nextEl: '.header-swiper-right',
        prevEl: '.header-swiper-left',
    },
});

// About Slider
let about_swiper = new Swiper(".about-swiper" , {
    slidesPerView: 1,
    spaceBetween: 12,
    breakpoints: {
        1200: {
            slidesPerView: 3,
            spaceBetween: 36
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 24
        },
        576: {
            slidesPerView: 2,
            spaceBetween: 20
        },
    },
    speed: 1000,
    pagination: {
        el: ".about-swiper-pagination",
        clickable: true
    }
});

// Dining Slider
let dining_swiper = new Swiper(".dining-swiper" , {
    autoplay: {
        delay: 3000,
    },
    slidesPerView: 1,
    spaceBetween: 8,
    speed: 1000,
    rewind: true,
    pagination: {
        el: ".dining-swiper-pagination",
        clickable: true
    },
    navigation: {
        nextEl: '.dining-swiper-right',
        prevEl: '.dining-swiper-left',
    },
});

// Dining Slider
let location_swiper = new Swiper(".location-swiper" , {
    autoplay: {
        delay: 3000,
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1500,
    loop: true,
    pagination: {
        el: ".location-swiper-pagination",
        clickable: true
    },
    navigation: {
        nextEl: '.location-swiper-right',
        prevEl: '.location-swiper-left',
    },
});

// Dishes Changer
let btn_dishes_changer = document.querySelector('#btnDishesChanger');
btn_dishes_changer.addEventListener('click', (e) => {
    btn_dishes_changer.style.pointerEvents = 'none';
    e.preventDefault();
    changeDishes()
    setTimeout(() => {
        btn_dishes_changer.style.pointerEvents = 'auto';
    },1000);
})
let all_card_dishes = document.querySelectorAll('.showcase-card');
function changeDishes(){
    all_card_dishes.forEach((el, index) => {
        if(index < 6){
            setTimeout(()=>{
                el.classList.remove('show');
            }, 100*index)
        }
        else{
            el.classList.remove('show');
        }
    })
    setTimeout(() => {
        // 交換位置
        swapPosition();
        // 重新拿新資料
        all_card_dishes = document.querySelectorAll('.showcase-card');

        all_card_dishes.forEach((el, index) => {
            if(index < 6){
                setTimeout(()=>{
                    el.classList.add('show');
                }, 100*index)
            }
            else{
                el.classList.add('show');
            }
        })
    }, 800);
}

// Video Changer
let brand_video = document.querySelector('.brand-video').querySelector('iframe');
let all_video_tabs = document.querySelector('.video-tabs').querySelectorAll('.tab');
all_video_tabs.forEach(tab => {
    tab.addEventListener('click', (e) => {
        all_video_tabs.forEach(tab => {tab.classList.remove('active')})
        tab.classList.add('active');
        e.preventDefault();
        let videoUrl = "https://www.youtube.com/embed/" + tab.dataset.id + "?autoplay=1&mute=0&enablejsapi=1";
        brand_video.setAttribute('src', videoUrl);
    })
});

function swapPosition(){
    // 將 NodeList 轉換為陣列
    let elementsArray = Array.from(document.querySelectorAll('.showcase-card'));

    // 創建一個新的隨機排序的陣列
    let shuffledArray = shuffleArray(elementsArray);

    // 創建一個文檔片段（Document Fragment），用於臨時存儲調整後的元素
    let fragment = document.createDocumentFragment();

    // 將隨機排序的元素添加到文檔片段中
    shuffledArray.forEach(function(element) {
        fragment.appendChild(element);
    });

    // 將文檔片段添加回原始的容器中
    let container = document.querySelector('#menu-showcase'); // 更換 '.container' 為您實際容器的選擇器
    container.innerHTML = '';
    container.appendChild(fragment);
}

function shuffleArray(array) {

    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
    return array;
}

// News Modal
document.addEventListener('DOMContentLoaded', () => {
    let newsModal = document.querySelector('#newsModal');
    if(newsModal) {
        window.scrollTo(0, 0)
        $('#newsModal').modal('show');
    }
})
